import { IAddUpdateDocumentoSetorialRequest } from "../../../../model/admin-portal/request/add-update-documento-setorial-request";
import { IDocumentoSetorialResponse } from "../../../../model/admin-portal/response/documento-setorial-response";
import { ITipoDocumentoSetorialResponse } from "../../../../model/admin-portal/response/tipo-documento-setorial-response";
import { ITermPaggedRequest } from "../../../../model/admin-portal/request/term-pagged-request";
import { PaginationResponse } from "../../../../model/base/response/pagination-response";

export type DocumentosSetoriaisState = {
    dataPaginatedListResponse: PaginationResponse<IDocumentoSetorialResponse>;
    isLoadingData: boolean;
    dataResponse: IDocumentoSetorialResponse | null;
    dataRequest: IAddUpdateDocumentoSetorialRequest;
    showAddEdit: boolean;
    dataSearchRequest: ITermPaggedRequest;
    tiposList: ITipoDocumentoSetorialResponse[];
};

export const initialDataRequest: IAddUpdateDocumentoSetorialRequest = {
    id: null,
    idTipoDocumentoSetorial: null,
    ano: null,
    periodo: null,
    textoDescricao: '',
    indStatus: null,
    dtaPublicacao: '',
    anexos: []
};

export const initialState: DocumentosSetoriaisState = {
    dataPaginatedListResponse: new PaginationResponse<IDocumentoSetorialResponse>(),
    isLoadingData: false,
    dataResponse: null,
    dataRequest: initialDataRequest,
    showAddEdit: false,
    dataSearchRequest: { page: 0, pageSize: 10, term: '' },
    tiposList: []
};

export enum ACTION_TYPES {
    setDataPaginatedListResponse = 'setDataPaginatedListResponse',
    setIsLoadingData = 'setIsLoadingData',
    setDataResponse = 'setDataResponse',
    setDataRequest = 'setDataRequest',
    setShowAddEdit = 'setShowAddEdit',
    setDataSearchRequest = 'setDataSearchRequest',
    setTiposList = 'setTiposList'
}

type Action =
    | { type: ACTION_TYPES.setDataPaginatedListResponse; payload: PaginationResponse<IDocumentoSetorialResponse> }
    | { type: ACTION_TYPES.setIsLoadingData; payload: boolean }
    | { type: ACTION_TYPES.setDataResponse; payload: IDocumentoSetorialResponse | null }
    | { type: ACTION_TYPES.setDataRequest; payload: IAddUpdateDocumentoSetorialRequest }
    | { type: ACTION_TYPES.setShowAddEdit; payload: boolean }
    | { type: ACTION_TYPES.setDataSearchRequest; payload: ITermPaggedRequest }
    | { type: ACTION_TYPES.setTiposList; payload: ITipoDocumentoSetorialResponse[] };

export const documentosSetoriaisReducer = (state: DocumentosSetoriaisState, action: Action): DocumentosSetoriaisState => {
    switch (action.type) {
        case ACTION_TYPES.setDataPaginatedListResponse:
            return { ...state, dataPaginatedListResponse: action.payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: action.payload };
        case ACTION_TYPES.setDataResponse:
            return { ...state, dataResponse: action.payload };
        case ACTION_TYPES.setDataRequest:
            return { ...state, dataRequest: action.payload };
        case ACTION_TYPES.setShowAddEdit:
            return { ...state, showAddEdit: action.payload };
        case ACTION_TYPES.setDataSearchRequest:
            return { ...state, dataSearchRequest: action.payload };
        case ACTION_TYPES.setTiposList:
            return { ...state, tiposList: action.payload };
        default:
            return state;
    }
};
